import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const LegalDisclaimer = (): JSX.Element => {
  const t = useTranslations();
  return (
    <TypographyV3 className="mb-12 mt-40">
      {t('legal_disclaimer_translations')}
    </TypographyV3>
  );
};

export default LegalDisclaimer;
